import { VaporTag, VaporTagProps } from "../VaporTag";
export const Tag = VaporTag;
export interface TagProps extends VaporTagProps {}
